export const appSettingsV2InternalUserGroupsInternalUserGroups =
  "/internal_user_groups/internal_user_groups_data_v2";
